
import { Component, Mixins } from "vue-property-decorator";
import { IFreeInputBehavior } from "../../../../../../documaker/domain/format/objects";
import { IFreeInputBehaviorPropertyEditable, instanceOfIFreeInputBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class FreeInputBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IFreeInputBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IFreeInputBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isFreeInputBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIFreeInputBehaviorPropertyEditable(s) && s.freeInputBehavior().isEditable(), false);
  }

  get freeInputBehavior(): IFreeInputBehavior {
    return this.readPropertyOrDefault(s => s.freeInputBehavior().getValue(), { isEnable: false });
  }

  set freeInputBehavior(value: IFreeInputBehavior) {
    this.writePropertyWhenValid(s => s.freeInputBehavior().setValue(value));
  }
}
